import { useEffect, useState } from "react";

interface AirHeaderScrollOptions {
  targetSelector?: string;
  scrollOffset?: number;
}

export function useAirHeaderScrolled({ targetSelector = "#top", scrollOffset }: AirHeaderScrollOptions = {}) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (scrollOffset !== undefined) {
      const syncScrolledState = () => setScrolled(window.scrollY > scrollOffset);

      syncScrolledState();
      window.addEventListener("scroll", syncScrolledState, { passive: true });
      return () => window.removeEventListener("scroll", syncScrolledState);
    }

    const target = document.querySelector(targetSelector);
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => setScrolled(!entry.isIntersecting),
      { rootMargin: "-72px 0px 0px" },
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [scrollOffset, targetSelector]);

  return scrolled;
}
